import cx from 'classnames';
import styles from '../../styles/homePage/nfoSection.scss';
import { HOME_PAGE_NFO_SECTION_CONTENT } from '../../constants/index';
import { Link } from '../../configs/routes';
import { CDN_CLRSAVE_URL } from '../../constants';
import Loader from '../ui/Loader';
import { truncate } from '../../utils/commonUtils';

const NfoSection = ({ nfos }) => {
  const {
    heading,
    subtitle,
    anchorLink,
    anchorText,
  } = HOME_PAGE_NFO_SECTION_CONTENT;
  return (
    <div className="mb40 mt40">
      <h2 className="font--dark-grey text--xxlg mobile-only--center mb10">
        {heading}
      </h2>
      <p className="text--lg font--grey mobile-only--text--xmd desktop-only line-height__1blKI">
        {subtitle}
      </p>
      {nfos.length > 0 ? (
        <div className={cx(styles['nfo-grid'], 'mt40')}>
          {(nfos || []).slice(0, 3).map(card => {
            const isNfoStateLive =
              card.nfoMetadata.nfoState && card.nfoMetadata.nfoState === 'LIVE';
            return (
              <Link
                route={`/mutual-funds/nfo/${card.parentSlug}/${card.slug}/${card.isinCode}`}
                key={card.productId}
              >
                <div
                  className={cx(
                    styles['nfo-card'],
                    'inline mb30 columns small-12 card__dgDaF p10 cursor--pointer'
                  )}
                  key={card.fundName}
                >
                  <img
                    src={`${CDN_CLRSAVE_URL}/clearsave${card.imageUrl}`}
                    className={cx(
                      styles['image'],
                      'mt10 mb10 mr10 ml10 float--left'
                    )}
                    alt={card.fundName}
                  />
                  <div className="large-7 large-offset-2">
                    <h5 className={cx('mt5 mb5 text--md')}>
                      {truncate(card.fundName, 36)}
                    </h5>

                    <p className="mt20 text--md">
                      Invest by{' '}
                      <b>
                        {(card.nfoMetadata && card.nfoMetadata.closeDate) || ''}
                      </b>
                    </p>
                  </div>
                  <div
                    className={cx(styles['nfo-btn'], 'inline', {
                      [styles['btn-red']]: isNfoStateLive,
                      [styles['btn-orange']]: !isNfoStateLive,
                    })}
                  >
                    {isNfoStateLive ? (
                      <img
                        src="https://assets1.cleartax-cdn.com/cleartax/images/1636449441_group18141235.svg"
                        alt="dot"
                      />
                    ) : null}
                    <span className="font--white text--sm ml5 mr5">
                      {(card.nfoMetadata && card.nfoMetadata.nfoState) || ''}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      ) : (
        <Loader />
      )}

      <a
        href={anchorLink}
        className="mb30 font--blue hollow-invest__uQjvi bold"
      >
        {anchorText}
      </a>
    </div>
  );
};
export default NfoSection;



// WEBPACK FOOTER //
// ./components/homePage/nfoSection.tsx